module.exports = __webpack_public_path__ + "static/media/img3-1.dad4ab4d.png";